import { render, staticRenderFns } from "./CaseRegimesGrid.vue?vue&type=template&id=1108cf0c&"
import script from "./CaseRegimesGrid.vue?vue&type=script&lang=js&"
export * from "./CaseRegimesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports